<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

  <div class="layout-padd divider light-grey" fxLayoutAlign="center center" fxLayout="column">
    <mat-icon class="secondary-ico">alarm</mat-icon>
    <span class="mat-title boldest">{{pricePeriod.name | uppercase}}</span>
  </div>

  <div class="layout-padd">

    <mat-list>

      <mat-list-item *ngFor="let day of pricePeriod.timetables; let i = index; let last = last;"
        [class.divider]="!last">

        <div fxLayout="row" fxLayoutGap="20px" fxLayoutGap.xs="10px" fxFlex>

          <div fxLayoutAlign="start center" fxFlex="25">
            <span class="mat-subheading-1">{{getDayByIndex(day.day) | capitalize}}</span>
          </div>

          <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="day.timeslots.length > 0">

            <div fxLayout="row" *ngFor="let slot of day.timeslots"
              [class.secondary-ico]="checkCurrentHour(slot) && checkCurrentDay(day.day)">

              <div>
                <span class="mat-subheading-1">{{slot.start | sheduleFilter}}</span>
              </div>

              <div>
                <span class="mat-subheading-1">-</span>
              </div>

              <div>
                <span class="mat-subheading-1">{{slot.end | sheduleFilter}}</span>
              </div>

            </div>

          </div>

          <div *ngIf="checkCurrentDay(day.day)" fxFlex fxLayoutAlign="end center">
            <i class="fas fa-caret-left secondary-ico" style="font-size: 1.5em;"></i>
          </div>

        </div>

      </mat-list-item>

    </mat-list>

  </div>

  <div class="layout-padd">

    <button mat-button class="full-w" (click)="closeDial()" angulartics2On="click"
      angularticsAction="closePromoShedulesDial" angularticsCategory="product">
      <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
    </button>

  </div>

</div>